import React, {useMemo} from 'react';
import styled from 'styled-components';
import * as PropTypes from 'prop-types';
import {StepButton} from './StepButton';
import {StepContent} from './StepContent';

const StepperStyle = styled.div`
	display: flex;

	user-select: none;
`;

export const Stepper = ({children, onBack, onForward, width, canNavigateBack, canNavigateForward, userpilot, cy}) => {
	const navigateBack = useMemo(() => (canNavigateBack ? onBack : undefined), [canNavigateBack, onBack]);
	const navigateForward = useMemo(() => (canNavigateForward ? onForward : undefined), [canNavigateForward, onForward]);

	return (
		<StepperStyle data-userpilot={userpilot} data-cy={cy}>
			<StepButton
				direction="back"
				enabled={canNavigateBack}
				onClick={navigateBack}
				userpilot={`${userpilot}-back`}
				cy={`${cy}-back`}
			/>
			<StepContent content={children} width={width} userpilot={`${userpilot}-content`} cy={`${cy}-content`} />
			<StepButton
				direction="forward"
				enabled={canNavigateForward}
				onClick={navigateForward}
				userpilot={`${userpilot}-forward`}
				cy={`${cy}-forward`}
			/>
		</StepperStyle>
	);
};

Stepper.propTypes = {
	/**
	 * What to be displayed in the content box. This is flexible and doesn't have to be text only. Content
	 * has to fit withing 30px height
	 */
	children: PropTypes.node.isRequired,
	/**
	 * Callback function, invoked when the user has clicked the back button
	 */
	onBack: PropTypes.func.isRequired,
	/**
	 * Callback function, invoked when the user has clicked the forward button
	 */
	onForward: PropTypes.func.isRequired,
	/**
	 * The width of the content box
	 */
	width: PropTypes.number.isRequired,
	/**
	 * Determines if it is possible click the navigate back.
	 */
	canNavigateBack: PropTypes.bool,
	/**
	 * Determines if it is possible click the navigate forward.
	 */
	canNavigateForward: PropTypes.bool,
	/**
	 * ID needed for on-boarding tool
	 */
	userpilot: PropTypes.string,
	/**
	 * ID needed for Cypress testing
	 */
	cy: PropTypes.string,
};

Stepper.defaultProps = {
	canNavigateBack: true,
	canNavigateForward: true,
};
